define('OutSystems/ReactWidgets/ListItem',["require", "exports", "tslib", "OutSystems/ReactView/HtmlTags", "OutSystems/ReactView/Widget", "react", "./Swipeable"], function (require, exports, tslib_1, HtmlTags_1, Widget_1, React, Swipeable_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.ListItem = exports.ListItemSwipeable = exports.ListItemBasic = exports.SwipeActions = void 0;
    var SwipeActions;
    (function (SwipeActions) {
        var Actions;
        (function (Actions) {
            Actions[Actions["RightVisible"] = 0] = "RightVisible";
            Actions[Actions["RightAction"] = 1] = "RightAction";
            Actions[Actions["LeftVisible"] = 2] = "LeftVisible";
            Actions[Actions["LeftAction"] = 3] = "LeftAction";
        })(Actions = SwipeActions.Actions || (SwipeActions.Actions = {}));
        var Directions;
        (function (Directions) {
            Directions[Directions["Left"] = 0] = "Left";
            Directions[Directions["Right"] = 1] = "Right";
        })(Directions = SwipeActions.Directions || (SwipeActions.Directions = {}));
    })(SwipeActions = exports.SwipeActions || (exports.SwipeActions = {}));
    var ListItemBasic = (function (_super) {
        tslib_1.__extends(ListItemBasic, _super);
        function ListItemBasic() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        ListItemBasic.prototype.render = function () {
            var listItemAttributes = {
                "data-list-item": "",
                "data-not-scrollable": "",
                onClick: this.props.containerClick,
                className: this.props.classProperty,
            };
            this.props.fillWithParentProperties(listItemAttributes);
            return React.createElement(HtmlTags_1.HtmlTags.div, listItemAttributes, this.props.placeholderContent.render());
        };
        return ListItemBasic;
    }(React.Component));
    exports.ListItemBasic = ListItemBasic;
    var ListItemSwipeable = (function (_super) {
        tslib_1.__extends(ListItemSwipeable, _super);
        function ListItemSwipeable(props, context) {
            var _a;
            var _this = _super.call(this, props, context) || this;
            _this.leftRef = React.createRef();
            _this.rightRef = React.createRef();
            _this.swipeRef = React.createRef();
            _this.touchWindowEventListener = function (e) {
                _this.unregisterTouchWindowEventListener();
                _this.animate();
            };
            _this.handleTouch = function (e) {
                if (!_this.propagateTouch) {
                    e.stopPropagation();
                }
            };
            _this.registerTouchWindowEventListener = function () {
                _this.propagateTouch = false;
                window.addEventListener(ListItemSwipeable.TouchStartEvent, _this.touchWindowEventListener);
            };
            _this.unregisterTouchWindowEventListener = function () {
                _this.propagateTouch = true;
                window.removeEventListener(ListItemSwipeable.TouchStartEvent, _this.touchWindowEventListener);
            };
            _this.onSwipingLeft = function (event, delta, startX) {
                _this.handleSwiping(false, event, delta, startX);
            };
            _this.onSwipingRight = function (event, delta, startX) {
                _this.handleSwiping(true, event, delta, startX);
            };
            _this.onSwiped = function () {
                var showRightButtons = false;
                var showLeftButtons = false;
                _this.setState({ showRightButtons: false, showLeftButtons: false });
                switch (_this.state.action) {
                    case SwipeActions.Actions.RightVisible:
                        _this.registerTouchWindowEventListener();
                        showRightButtons = true;
                        break;
                    case SwipeActions.Actions.LeftVisible:
                        _this.registerTouchWindowEventListener();
                        showLeftButtons = true;
                        break;
                    case SwipeActions.Actions.LeftAction:
                        var element_1 = _this.leftRef.current.children[0];
                        if (element_1) {
                            _this.timeoutClickHandle = setTimeout(function () { return element_1.click(); }, _this.props.animationTimeout);
                        }
                        break;
                    case SwipeActions.Actions.RightAction:
                        var actions = _this.rightRef.current.children;
                        if (actions.length > 0) {
                            var element_2 = actions[actions.length - 1];
                            if (element_2) {
                                _this.timeoutClickHandle = setTimeout(function () { return element_2.click(); }, _this.props.animationTimeout);
                            }
                        }
                        break;
                    default:
                        break;
                }
                _this.setState({
                    deltaPixels: 0,
                    action: null,
                    showRightButtons: showRightButtons,
                    showLeftButtons: showLeftButtons,
                    swipingLeft: false,
                    swipingRight: false,
                    animating: true,
                    animatingFullSwipeRight: _this.state.action === SwipeActions.Actions.LeftAction,
                    animatingFullSwipeLeft: _this.state.action === SwipeActions.Actions.RightAction,
                });
                _this.startAnimationTimeout();
            };
            _this.handleActionContainerClick = function (event) {
                _this.animate();
                event.stopPropagation();
            };
            _this.handleContentClick = function (event) {
                if (_this.state.showRightButtons || _this.state.showLeftButtons) {
                    return;
                }
                if (!_this.state.animating) {
                    _this.props.containerClick(event);
                }
            };
            _this.state = {
                deltaPixels: 0,
                showRightButtons: false,
                showLeftButtons: false,
                swipingLeft: false,
                swipingRight: false,
                animating: false,
                action: null,
                callActionWhenSwipingFarRight: false,
                callActionWhenSwipingFarLeft: false,
                lastContainerClass: "",
                shouldRenderActions: (_a = props.isExpandedInWebEditor) !== null && _a !== void 0 ? _a : false,
                animatingFullSwipeRight: false,
                animatingFullSwipeLeft: false,
            };
            _this.propagateTouch = true;
            _this.actionsMaxWidth = 0;
            _this.leftPlaceholderCache = null;
            _this.rightPlaceholderCache = null;
            _this.contentPlaceholderCache = null;
            return _this;
        }
        ListItemSwipeable.prototype.startAnimationTimeout = function () {
            var _this = this;
            this.clearAnimationTimeout();
            this.animationTimeoutHandle = setTimeout(function () {
                _this.setState({
                    animating: false,
                    action: null,
                    animatingFullSwipeRight: false,
                    animatingFullSwipeLeft: false,
                    shouldRenderActions: _this.state.showLeftButtons || _this.state.showRightButtons,
                });
            }, this.props.animationTimeout);
        };
        ListItemSwipeable.prototype.clearAnimationTimeout = function () {
            if (this.animationTimeoutHandle) {
                clearTimeout(this.animationTimeoutHandle);
            }
        };
        ListItemSwipeable.prototype.clearClickTimeout = function () {
            if (this.timeoutClickHandle) {
                clearTimeout(this.timeoutClickHandle);
            }
        };
        ListItemSwipeable.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
            this.leftPlaceholderCache = null;
            this.rightPlaceholderCache = null;
            this.contentPlaceholderCache = null;
        };
        ListItemSwipeable.prototype.componentDidMount = function () {
            if (this.props.extendedProperties) {
                var swipeLeftEdgeCustom = this.props.extendedProperties[ListItemSwipeable.SwipeLeftEdgeThresholdExtended];
                var swipeRightEdgeCustom = this.props.extendedProperties[ListItemSwipeable.SwipeRightEdgeThresholdExtended];
                if (swipeLeftEdgeCustom) {
                    this.swipeLeftEdgeThreshold = parseInt(swipeLeftEdgeCustom, 10);
                }
                if (swipeRightEdgeCustom) {
                    this.swipeRightEdgeThreshold = parseInt(swipeRightEdgeCustom, 10);
                }
            }
        };
        ListItemSwipeable.prototype.componentDidUpdate = function () {
            if (this.state.lastContainerClass !== this.lastContainerClass) {
                this.setState({ lastContainerClass: this.lastContainerClass });
            }
        };
        ListItemSwipeable.prototype.componentWillUnmount = function () {
            this.clearAnimationTimeout();
            this.clearClickTimeout();
            this.unregisterTouchWindowEventListener();
        };
        ListItemSwipeable.prototype.updateElementCachedInfo = function () {
            var element = this.swipeRef.current;
            if (!this.actionsMaxWidth) {
                var actionElement = element.querySelector("[data-list-item-action]");
                if (actionElement) {
                    this.actionsMaxWidth = parseInt(window.getComputedStyle(actionElement, null).getPropertyValue("max-width"), 10);
                }
            }
            this.leftActionsCount = element
                .getElementsByClassName(ListItemSwipeable.LeftActions)[0]
                .getElementsByTagName(ListItemSwipeable.Button).length;
            this.rightActionsCount = element
                .getElementsByClassName(ListItemSwipeable.RightActions)[0]
                .getElementsByTagName(ListItemSwipeable.Button).length;
            this.contentWidth = element.querySelector("[data-list-item-content]").clientWidth;
            ListItemSwipeable.deviceWidth = window.innerWidth || document.documentElement.clientWidth;
        };
        ListItemSwipeable.prototype.showFullSwipe = function () {
            return (this.state.action === SwipeActions.Actions.LeftAction ||
                this.state.action === SwipeActions.Actions.RightAction ||
                this.state.animatingFullSwipeLeft ||
                this.state.animatingFullSwipeRight);
        };
        ListItemSwipeable.prototype.getSwipeLeftEdgeThreshold = function () {
            if (this.swipeLeftEdgeThreshold) {
                return this.swipeLeftEdgeThreshold;
            }
            return ListItemSwipeable.SwipeLeftEdgeDefaultThreshold;
        };
        ListItemSwipeable.prototype.getSwipeRightEdgeThreshold = function () {
            if (this.swipeRightEdgeThreshold) {
                return this.swipeRightEdgeThreshold;
            }
            return ListItemSwipeable.SwipeRightEdgeDefaultThreshold;
        };
        ListItemSwipeable.prototype.getSwipeThresholdToTriggerAction = function (direction) {
            if (this.state.showLeftButtons || this.state.showRightButtons) {
                return this.actionsMaxWidth * 0.75;
            }
            if (direction === SwipeActions.Directions.Right) {
                return this.actionsMaxWidth * (Math.min(2, this.leftActionsCount) + 0.75);
            }
            return this.actionsMaxWidth * (Math.min(2, this.rightActionsCount) + 0.75);
        };
        ListItemSwipeable.prototype.handleSwiping = function (right, event, delta, startX) {
            this.updateElementCachedInfo();
            this.setState({ shouldRenderActions: true });
            var direction = right ? SwipeActions.Directions.Right : SwipeActions.Directions.Left;
            if (this.swipingHandleStylesAndDelta(delta, direction, startX)) {
                return;
            }
            var action = null;
            if (delta > this.props.visibilityThreshold) {
                action = right ? SwipeActions.Actions.LeftVisible : SwipeActions.Actions.RightVisible;
            }
            var callAction = right
                ? this.props.callActionWhenSwipingFarRight
                : this.props.callActionWhenSwipingFarLeft;
            if (callAction && delta > this.getSwipeThresholdToTriggerAction(direction)) {
                action = right ? SwipeActions.Actions.LeftAction : SwipeActions.Actions.RightAction;
            }
            var realDelta = delta - ListItemSwipeable.SwipeStartThreshold;
            this.setState({
                deltaPixels: right ? realDelta : -realDelta,
                action: action,
                swipingLeft: !right,
                swipingRight: right,
            });
        };
        ListItemSwipeable.prototype.getActionsPlaceholderStyle = function (right) {
            var left = !right;
            var actionsCount = left ? this.leftActionsCount : this.rightActionsCount;
            var swiping = (left && this.state.swipingRight) || (right && this.state.swipingLeft);
            var showingButtons = (left && this.state.showLeftButtons) ||
                (right && this.state.showRightButtons) ||
                this.props.isExpandedInWebEditor;
            var animatingFullSwipe = (left && this.state.animatingFullSwipeRight) || (right && this.state.animatingFullSwipeLeft);
            if (swiping) {
                var offset = 0;
                if (showingButtons && !this.state.animating) {
                    offset = actionsCount * this.actionsMaxWidth;
                }
                return {
                    width: Math.abs(this.state.deltaPixels) + offset + "px",
                };
            }
            if (showingButtons) {
                return {
                    width: this.props.isExpandedInWebEditor ? "auto" : actionsCount * this.actionsMaxWidth + "px",
                };
            }
            if (animatingFullSwipe) {
                return {
                    width: this.contentWidth + "px",
                };
            }
            return null;
        };
        ListItemSwipeable.prototype.swipingHandleStylesAndDelta = function (delta, direction, startX) {
            if (this.shouldAbort(direction, startX)) {
                return true;
            }
            this.tryAnimate(direction);
            return false;
        };
        ListItemSwipeable.prototype.shouldAbort = function (direction, startX) {
            if (direction === SwipeActions.Directions.Right) {
                if (startX < this.getSwipeRightEdgeThreshold()) {
                    return true;
                }
            }
            else {
                if (startX > ListItemSwipeable.deviceWidth - this.getSwipeLeftEdgeThreshold()) {
                    return true;
                }
            }
            if (this.state.animating) {
                return true;
            }
            if (direction === SwipeActions.Directions.Right) {
                return ((!this.leftActionsCount && !this.state.showRightButtons) ||
                    (this.state.showLeftButtons && !this.props.callActionWhenSwipingFarRight));
            }
            else {
                return ((!this.rightActionsCount && !this.state.showLeftButtons) ||
                    (this.state.showRightButtons && !this.props.callActionWhenSwipingFarLeft));
            }
        };
        ListItemSwipeable.prototype.tryAnimate = function (direction) {
            if ((direction === SwipeActions.Directions.Right && this.state.showRightButtons) ||
                (direction === SwipeActions.Directions.Left && this.state.showLeftButtons)) {
                this.animate();
            }
        };
        ListItemSwipeable.prototype.animate = function () {
            this.setState({
                showLeftButtons: false,
                showRightButtons: false,
                animating: true,
            });
            this.startAnimationTimeout();
        };
        ListItemSwipeable.prototype.getContainerClass = function () {
            if (this.state.animating) {
                return this.state.lastContainerClass;
            }
            var lastContainerClass = null;
            if (this.state.showRightButtons) {
                lastContainerClass = ListItemSwipeable.FloatRight;
            }
            else if (this.state.showLeftButtons) {
                lastContainerClass = ListItemSwipeable.FloatLeft;
            }
            else {
                lastContainerClass =
                    this.state.deltaPixels < 0 ? ListItemSwipeable.FloatRight : ListItemSwipeable.FloatLeft;
            }
            return lastContainerClass;
        };
        ListItemSwipeable.prototype.getRenderedLeftPlaceholder = function () {
            if (this.state.shouldRenderActions) {
                if (this.leftPlaceholderCache === null) {
                    this.leftPlaceholderCache = this.props.placeholderLeftActions.render();
                }
                return this.leftPlaceholderCache;
            }
            return null;
        };
        ListItemSwipeable.prototype.getRenderedRightPlaceholder = function () {
            if (this.state.shouldRenderActions) {
                if (this.rightPlaceholderCache === null) {
                    this.rightPlaceholderCache = this.props.placeholderRightActions.render();
                }
                return this.rightPlaceholderCache;
            }
            return null;
        };
        ListItemSwipeable.prototype.getRenderedContentPlaceholder = function () {
            if (this.contentPlaceholderCache === null) {
                this.contentPlaceholderCache = this.props.placeholderContent.render();
            }
            return this.contentPlaceholderCache;
        };
        ListItemSwipeable.prototype.render = function () {
            this.lastContainerClass = this.getContainerClass();
            var classes = ListItemSwipeable.Container + (this.showFullSwipe() ? " " + ListItemSwipeable.FullSwipe : "");
            if (this.state.animating) {
                classes += " " + ListItemSwipeable.Animating;
            }
            if (this.state.showRightButtons) {
                classes += " " + ListItemSwipeable.ShowRightButtons;
            }
            if (this.state.showLeftButtons) {
                classes += " " + ListItemSwipeable.ShowLeftButtons;
            }
            var swipeableProperties = {
                "data-list-item-content": "",
                "data-not-scrollable": "",
                className: this.props.classProperty,
                onSwipingLeft: this.onSwipingLeft,
                onClick: this.handleContentClick,
                onSwipingRight: this.onSwipingRight,
                delta: ListItemSwipeable.SwipeStartThreshold,
                onSwiped: this.onSwiped,
            };
            this.props.fillWithParentProperties(swipeableProperties);
            var ref = swipeableProperties.ref;
            swipeableProperties.ref = null;
            return React.createElement(HtmlTags_1.HtmlTags.div, {
                "data-list-item": "",
                "data-not-scrollable": "",
                ref: ref,
            }, React.createElement(HtmlTags_1.HtmlTags.div, {
                className: classes + " " + this.lastContainerClass,
                ref: this.swipeRef,
                onTouchStart: this.handleTouch,
            }, React.createElement(HtmlTags_1.HtmlTags.div, {
                className: ListItemSwipeable.LeftActions,
                style: this.getActionsPlaceholderStyle(false),
                onClick: this.handleActionContainerClick,
                ref: this.leftRef,
            }, this.getRenderedLeftPlaceholder()), React.createElement(Swipeable_1.Swipeable, swipeableProperties, this.getRenderedContentPlaceholder()), React.createElement(HtmlTags_1.HtmlTags.div, {
                className: ListItemSwipeable.RightActions,
                style: this.getActionsPlaceholderStyle(true),
                onClick: this.handleActionContainerClick,
                ref: this.rightRef,
            }, this.getRenderedRightPlaceholder())));
        };
        ListItemSwipeable.TouchStartEvent = "touchstart";
        ListItemSwipeable.Button = "button";
        ListItemSwipeable.Container = "list-item-container";
        ListItemSwipeable.LeftActions = "list-item-left-actions";
        ListItemSwipeable.RightActions = "list-item-right-actions";
        ListItemSwipeable.FloatRight = "list-item-float-right";
        ListItemSwipeable.FloatLeft = "list-item-float-left";
        ListItemSwipeable.FullSwipe = "list-item-full-swipe";
        ListItemSwipeable.Animating = "list-item-animating";
        ListItemSwipeable.ShowRightButtons = "list-item-show-right-buttons";
        ListItemSwipeable.ShowLeftButtons = "list-item-show-left-buttons";
        ListItemSwipeable.SwipeStartThreshold = 15;
        ListItemSwipeable.SwipeLeftEdgeThresholdExtended = "list-item-swipe-left-edge-threshold";
        ListItemSwipeable.SwipeRightEdgeThresholdExtended = "list-item-swipe-right-edge-threshold";
        ListItemSwipeable.SwipeLeftEdgeDefaultThreshold = 15;
        ListItemSwipeable.SwipeRightEdgeDefaultThreshold = 15;
        return ListItemSwipeable;
    }(React.Component));
    exports.ListItemSwipeable = ListItemSwipeable;
    var ListItem = (function (_super) {
        tslib_1.__extends(ListItem, _super);
        function ListItem() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.handleClick = function (event) {
                if (_this.props.onClick) {
                    event.stopPropagation();
                    _this.executeWithActiveClassOn(function () { return _this.props.onClick(); });
                }
            };
            return _this;
        }
        ListItem.prototype.render = function () {
            var _this = this;
            var _a;
            var leftPlaceholderEmpty = this.props.placeholders.leftActions === Widget_1.PlaceholderContent.Empty;
            var rightPlaceholderEmpty = this.props.placeholders.rightActions === Widget_1.PlaceholderContent.Empty;
            if (leftPlaceholderEmpty && rightPlaceholderEmpty) {
                return React.createElement(ListItemBasic, {
                    containerClick: this.handleClick,
                    placeholderContent: this.props.placeholders.content,
                    fillWithParentProperties: function (attributes) {
                        return _this.fillWithBuiltinProperties(attributes);
                    },
                    classProperty: this.props.style,
                }, null);
            }
            else {
                return React.createElement(ListItemSwipeable, {
                    extendedProperties: this.props.extendedProperties,
                    visibilityThreshold: 35,
                    animationTimeout: 400,
                    placeholderContent: this.props.placeholders.content,
                    placeholderLeftActions: this.props.placeholders.leftActions,
                    placeholderRightActions: this.props.placeholders.rightActions,
                    callActionWhenSwipingFarRight: this.props.triggerActionOnFullSwipeRight,
                    callActionWhenSwipingFarLeft: this.props.triggerActionOnFullSwipeLeft,
                    isExpandedInWebEditor: (_a = this.props.expandedInWebEditor) !== null && _a !== void 0 ? _a : false,
                    containerClick: this.handleClick,
                    fillWithParentProperties: function (attributes) {
                        return _this.fillWithBuiltinProperties(attributes);
                    },
                    classProperty: this.props.style,
                }, null);
            }
        };
        ListItem = tslib_1.__decorate([
            Widget_1.WidgetSpec
        ], ListItem);
        return ListItem;
    }(Widget_1.Widget));
    exports.ListItem = ListItem;
});
//# sourceMappingURL=ListItem.js.map;
